import { propertyTransferReducer } from 'components/property_transfer/store/slice'

export const propertyTransferReducers = {
  propertyTransfer: propertyTransferReducer,
}
